<template>
  <Card class="tasks-table">
    <template #header>
      <slot name="header">
        <div class="tasks-table__title row between middle">
          <h2>{{ title || $tc('task', 2) }}</h2>
          <slot name="info" />
        </div>
      </slot>
      <div class="tasks-table__filter">
        <CheckboxComponent v-model="showAll" :label="$t('showAll')" />
        <FilterComponent
          v-model="filter"
          :default="defaultFilter"
          v-on="{ reset: reset }"
          :items="['search']"
          :persist="false"
          :options="{ search: { placeholder: [$t('title')] } }"
        />
      </div>
    </template>

    <div class="tasks-table__scroller">
      <TaskList
        :columns="[
          { id: 'title', label: this.$t('title') },
          { id: 'status', label: this.$t('status') },
          { id: 'dueAt', label: this.$t('deadline') },
          { id: 'members', label: this.$tc('member', 2) },
          { id: 'createdBy', label: this.$t('createdBy'), component: 'Members' },
          { id: 'updatedAt', label: this.$t('lastUpdated') },
        ]"
        :filter="filter"
        theme="border"
      />
    </div>

    <template #footer>
      <slot name="actions" />
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import FilterMixin from '@/components/Filter'
import FilterComponent from '@/components/Filter/Component'
import { CheckboxComponent } from 'vue-elder-checkbox'
import TaskList from '@/components/Task/List/Component'

export default {
  mixins: [FilterMixin({ default: 'defaultFilter' })],
  props: {
    defaultFilter: {
      type: Object,
      default: () => ({ search: '', status: ['undone', 'request'] }),
    },
    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    showAll: {
      get() {
        return this.filter.status && !this.filter.status.length
      },
      set(val) {
        this.filter.status = val ? [] : this.defaultFilter.status
      },
    },
  },
  methods: {
    reset() {
      this.filter.status = this.defaultFilter.status
    },
  },
  components: {
    CheckboxComponent,
    Card,
    TaskList,
    FilterComponent,
  },
}
</script>

<style lang="scss">
.tasks-table {
  &__title {
    flex-grow: 1;
    h2 {
      margin: 0;

      @include respond-below('phone') {
        font-size: 1.2em;
      }
    }
  }

  &__scroller {
    max-height: 800px;
    overflow: auto;

    @include scrollShadow();

    @include respond-below('phone') {
      max-width: calc(100vw - 4rem);
    }
  }

  .card {
    &__header {
      flex-direction: row;
      min-height: initial;
      padding: 1rem 2rem;
      justify-content: space-between;
      gap: 1rem;

      @include respond-below('tablet') {
        flex-direction: column;
        align-items: start;
      }
    }
  }

  &__filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    .elder-input__label {
      display: none;
    }
    .elder-input__wrapper {
      margin-top: 0;
    }
  }
}
</style>
